import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 32px 16px;
  background-color: #ffffff;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 6px;
`;

export const SectionSubtitle = styled.div`
  font-size: 14px;
  color: #64748b;
  text-align: center;
  margin-bottom: 24px;
`;

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f8fafc;
  padding: 12px 14px;
  border-radius: 10px;
  border-left: 4px solid #8b5cf6;
`;

export const StepNumber = styled.span`
  font-size: 14px;
  font-weight: 800;
  color: #8b5cf6;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StepTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
`;

export const StepDesc = styled.div`
  font-size: 12px;
  color: #64748b;
  margin: 0;
`;

export const PreviewContainer = styled.div`
  background: #f8fafc;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #f1f5f9;
`;

export const PreviewHeader = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const VkCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  border: 1px solid #f1f5f9;
`;

export const VkHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const VkAvatar = styled.div`
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #8b5cf6, #ec4899);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
`;

export const VkMeta = styled.div`
  display: flex;
  flex-direction: column;
`;

export const VkBusinessName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
`;

export const VkTime = styled.span`
  font-size: 11px;
  color: #94a3b8;
`;

export const VkImageMock = styled.div`
  width: 100%;
  height: 150px;
  background: linear-gradient(135deg, #f5f3ff 0%, #fce7f3 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 10px;
  text-align: center;
  padding: 0 16px;
`;

export const VkTextContent = styled.div`
  font-size: 13px;
  color: #334155;
  line-height: 1.45;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const VkHeadline = styled.strong`
  color: #0f172a;
  font-size: 14px;
`;

export const VkCta = styled.div`
  color: #8b5cf6;
  font-weight: 600;
  font-size: 13px;
`;

export const VkTags = styled.div`
  color: #ec4899;
  font-size: 12px;
`;
